module.exports = __webpack_public_path__ + "static/media/menu-icon-challenge-locked.974439e4.png";